import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'
import { AppErrorBoundary } from '@/app/AppErrorBoundary'
import { AppProviders } from '@/app/AppProviders'
import { detectFreshLogin } from '@/auth/utils/freshLoginMarker'
import { DevTools } from '@/core/components/DevTools'
import { env } from '@/env'

import './init'
import './styles'

// Keycloak removes the authorization response from the URL during init, so
// detect an interactive login before rendering the authentication provider.
detectFreshLogin()

function renderApp() {
  const rootElement = document.getElementById('root')

  if (rootElement === null) {
    throw new Error('Root container missing in index.html')
  }

  createRoot(rootElement).render(
    <AppErrorBoundary>
      <AppProviders>
        <StrictMode>
          <App />
        </StrictMode>
        {env.MODE !== 'production' && <DevTools />}
      </AppProviders>
    </AppErrorBoundary>,
  )
  console.info('APP_VERSION:', env.APP_VERSION)
}

// Setup MSW mock server in development.
// Use import.meta.env.DEV (not env.DEV) so Vite excludes MSW from staging and production builds.
if (import.meta.env.DEV && env.REACT_APP_MSW_ENABLED) {
  import('./test/server/browser').then(({ worker }) => {
    worker.start({
      onUnhandledRequest: 'bypass',
    })

    renderApp()
  })
} else {
  renderApp()
}
